import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

@Component({
  selector: 'app-bottom-nav',
  standalone: true,
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss']
})
export class BottomNavComponent {
  @Input() cameraLink: any[] = ['/camera'];
  @Input() sendLink: any[] = ['/chat'];

  @Output() shareClick = new EventEmitter<void>();

  @Input() onNavigate?: () => void;

  constructor(private router: Router, private readonly authService: AuthService) {}

  navigate(route: any[]) {
    if (!this.authService.getMagicLinkToken()) return;
    this.onNavigate?.();
    this.router.navigate(route);
  }

  share() {
    this.onNavigate?.();
    this.shareClick.emit();
  }
}
